<template lang="html">
    <div id="page__autos" class="center-panel">
        <md-content class="md-elevation-1" md-theme="white" v-loader-overlay="progress">
            <sort-table 
                v-bind:columns="tableColumns" v-model="autos" @refresh="getAutos" v-bind:per-page="perPage" 
                v-bind:total="autoAmount" link table-id="autos" ref="table" v-on:create="addAuto"
            >
                <template slot="type" slot-scope="scope">
                    <span> {{ getTypeLabel(scope.item.type) }} </span>
                </template>

                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import SortTable from '@/components/SortTable';
    import ZIconButton from '@/components/ZIconButton';
    export default {
        components: { SortTable, ZIconButton },
        data() {
            return {
                perPage: 25,
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },

                    { label: 'Номер', field: 'number', sortable: true},
                    { label: 'Марка', field: 'brand'},
                    { label: 'Тип',   field: 'type', sortable: true},

                    { label: 'Макс. мест',  field: 'max_seats', sortable: true},
                    { label: 'Макс. вес',   field: 'max_weight', sortable: true},
                    { label: 'Макс. объём', field: 'max_volume', sortable: true},

                    { label: '', field: 'actions' },
                ],
                deleteDialog: false,
                autoToDelete: {}
            }
        },
        metaInfo() {
            return {
                title: 'Автомобили'
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
             progress() {
                return this.progressObj['autos-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },            
            /**
             * Получение ТС из стора
             */
            autos() {
                return !this.$store.state.deals.autos ? [] :  this.$store.state.deals.autos.map(auto => {
                    auto.routerLink = { name: 'Auto', params: { auto_id: auto.id }, query: this.$route.query };
                    return auto;
                });
            },
            /**
             * Количество ТС
             */
            autoAmount() {
                return this.$store.state.deals.autos_amount
            }
        },
        created() {
            this.$store.commit('setTitle', this.title)
        },
        methods: {
            /**
             * Добавление ТС
             */
            addAuto() {
                this.$router.push({ name: 'Auto', params: { auto_id: 'new' } });
            },
            /**
             * Получение ТС
             */
            getAutos(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'autos-list');
                return this.$store.dispatch('deals/getAutos', {
                    page: page, order_by: orderBy, order_type: orderType, count: count, filter: this.resolveQueryFilter()
                }).finally(() => this.$store.commit('hideProgressBar', 'autos-list'));
            },
            /**
             * Фильтрация
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return null;
                let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

                if (filter.search) model.push(['number', '%', filter.search]);

                if (filter.type) model.push(['type', '=', filter.type]);

                model.map((item, i) => {
                    result.model.push(item);
                    if (model[i+1]) result.model.push('and')
                });
                return result
            },
            /**
             * Удаление ТС
             */
            removeAuto(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'autos-list');
                this.$store.dispatch('deals/deleteAuto', id)
                    .then(() => this.$root.$emit('refresh-table', 'autos'))
                    .finally(() => this.$store.commit('hideProgressBar', 'autos-list'));
            },
            /**
             * Модальное окно с удалением ТС
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении группы', 'Действие необратимо!',
                    () => this.removeAuto(id)
                );
            },
            /**
             * Определение типа ТС
             */
            getTypeLabel(type) {
                switch (parseInt(type)) {
                    case 0: return 'Не установлен';
                    case 1: return 'Автофургон';
                    case 2: return 'Тягач';
                    case 3: return 'Прицеп';
                }
                return 'Не установлен';
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Autos.vue?13f3a562